/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */

import { Injectable } from '@angular/core';
import { Http, XHRBackend, RequestOptions, Request, RequestOptionsArgs, Response, Headers } from '@angular/http';

import { Observable } from 'rxjs/Observable';
// import '@api/rxjs-operators';

declare var window: any;

/**
 * HttpService integrated to the Angular HTTP
 */
@Injectable()
export class HttpThresholdService extends Http {

    private tokenKey: string = 'authorizationData';
    private isLoggedIn: boolean;
    protected token: string;
    

    /**
     * Create the instance of HttpService
     * @param backend The instance of XHRBackend
     * @param options The instance of RequestOptions
     */
    constructor(backend: XHRBackend, options: RequestOptions) {
        super(backend, options);

        this.isLoggedIn = sessionStorage.getItem(this.tokenKey) ? true: false;
        this.token = this.isLoggedIn ? sessionStorage.getItem(this.tokenKey) : null;

        if (this.isLoggedIn) options.headers.set('Authorization', `Bearer ${this.token}`);

        options.headers.append('Content-Type', 'application/json');
        options.headers.append('Accept', 'application/json');
    }

    /**
     * Overridden method injecting the OpenID's Authorization token into the each request
     * @param url Url to intercept
     * @param options Extra options
     */
    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        return super.request(url, options);
    }

    /**
     * 
     * @param url 
     * @param body 
     * @param options 
     */
    post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
        return super.post(url, body, options);
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/http-threshold.service.ts